import React, { useEffect, useState } from "react";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import "./CeroKm.css";
import Loader from "../Loader/Loader";
import NavigationButtons from "../NavigationButtons/NavigationButtons";
import { useNavigate } from "react-router-dom";
import WhatsApp from "../WhatsApp/WhatsApp";

const normalizarMarca = (marca) => {
  return marca
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-");
};

const CeroKm = () => {
  const [marcas, setMarcas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storage = getStorage();
    const folderRef = ref(storage, "Autos/nuevos");

    listAll(folderRef)
      .then((res) => {
        return Promise.all(
          res.prefixes.map((folder) => {
            return listAll(folder).then((res) => {
              const jsonFile = res.items.find((item) =>
                item.name.endsWith(".json")
              );

              if (!jsonFile) return null;

              return getDownloadURL(jsonFile)
                .then((jsonUrl) => fetch(jsonUrl))
                .then((response) => response.json())
                .then((jsonData) => {
                  if (!jsonData.Marca) return null;

                  return {
                    nombre: jsonData.Marca,
                    slug: normalizarMarca(jsonData.Marca),
                  };
                })
                .catch((error) => {
                  console.error("Error leyendo JSON en", folder.name, error);
                  return null;
                });
            });
          })
        );
      })
      .then((resultados) => {
        const marcasValidas = resultados.filter(Boolean);

        const marcasUnicas = marcasValidas.filter(
          (marca, index, self) =>
            index === self.findIndex((m) => m.slug === marca.slug)
        );

        setMarcas(marcasUnicas);
        setIsLoading(false);
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, []);

  return (
    <div>
      {isLoading ? (
        <Loader isLoading={isLoading} />
      ) : (
        <>
          <h2 className="text-center text-2xl font-bold mt-4 mb-4">
            Nuestros 0KM
          </h2>

          <p className="text-center text-lg mb-8">
            Elegí una marca para ver los modelos disponibles
          </p>

          <div className="marcas-grid">
            {marcas.map((marca) => (
              <button
                key={marca.slug}
                onClick={() => navigate(`/nuevos/marca/${marca.slug}`)}
                className="marca-card"
              >
                <img
                  src={`https://firebasestorage.googleapis.com/v0/b/tortoneautomotores-b9f5f.appspot.com/o/logos%2F${marca.slug}.png?alt=media`}
                  alt={marca.nombre}
                  className="marca-logo"
                />
                {/* <span className="marca-nombre">{marca.nombre}</span> */}
              </button>
            ))}
          </div>

          <div className="flex justify-center">
            <div className="w-4/5 sm:w-3/5 text-center text-justify mt-10 mb-16">
              <h4 className="text-2xl font-extrabold mb-6">
                En nuestra agencia multimarca de vehículos 0km, ofrecemos
                ventajas distintivas que hacen de tu experiencia de compra mucho
                más agradable:
              </h4>
              <ul className="list-disc list-inside space-y-2 text-lg font-semibold">
                <li>
                  Valor justo por tu vehículo: Nos comprometemos a ofrecerte el
                  mejor precio del mercado por tu vehículo usado al momento de
                  adquirir un 0km.
                </li>
                <li>
                  Stock físico disponible: Contamos con un amplio stock físico
                  de vehículos, lo que nos permite garantizar una entrega
                  inmediata sin largas esperas.
                </li>
                <li>
                  Llave contra llave: Implementamos el concepto de llave contra
                  llave, donde tú nos entregas tu vehículo usado al momento de
                  recibir tu vehículo 0km, asegurando una transacción segura y
                  confiable para ambas partes.
                </li>
              </ul>
            </div>
          </div>

          <WhatsApp />
          <NavigationButtons />
        </>
      )}
    </div>
  );
};

export default CeroKm;